import React from "react";
import ReactDOM from "react-dom";
import process from "process";
window.process = process;


import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { StylesProvider } from "@mui/styles";
import { theme } from "./theme/theme";

import { QueryClient, QueryClientProvider } from "react-query";

import { AppProvider } from "./contexts/app-provider";
import { LanguageProvider } from "./providers/LanguageProvider";
import { DialogProvider } from "./contexts/dialog-provider";
import { UserProvider } from "./contexts/user-provider";
import { TnCProvider } from "./providers/TnCProvider";
import { App } from "./App";

import reportWebVitals from "./reportWebVitals";

import "./i18n";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider injectFirst>{/* (Deprecated in v5) Keep it while migrating from v4, as we still rely on JSS-based styles (makeStyles, withStyles) */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppProvider>
          <QueryClientProvider client={queryClient}>
            <LanguageProvider>
              <DialogProvider>
                <UserProvider>
                  <TnCProvider>
                    <App />
                  </TnCProvider>
                </UserProvider>
              </DialogProvider>
            </LanguageProvider>
          </QueryClientProvider>
        </AppProvider>
      </ThemeProvider>
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
